<div class="container-fluid from-top">
    <div class="row">
        <div class="col-md-12">
            <h1>
                <ng-container *ngFor="let catalog of catalogTitle">
                    <a class="cursor-po-c text-style" [href]="'#/catalogs/' + catalog.id" *ngIf="!catalog.isCurrent">{{catalog.name}}</a>
                    <span *ngIf="!catalog.isCurrent"> / </span>
                    <span class="cursor-def text-style" *ngIf="catalog.isCurrent">{{catalog.name}}</span>
                </ng-container>
            </h1>
        </div>
        <div class="col-md-12 my-5 clr-sec-text text-center" *ngIf="!assets">
            <h2>{{'gen_no_data' | translate}}</h2>
        </div>
    </div>
    <div infiniteScroll [infiniteScrollDistance]="2" (scrolled)="onScroll()">
        <app-waterfall [assets]="assets"></app-waterfall>
    </div>

    <!-- Ad Banner -->
    <div class="row my-5">
        <div class="col-md-6 mx-auto" id="CATALOG_BANNER"></div>
    </div>
</div>